import React, { useState, useEffect, useMemo } from 'react'
import {
  filtrarArray,
  formatFilters,
  initialChangeFalse,
  initialChangeTrue,
  initialForm,
} from '@auteco/constants'
import { Card, Typography, Button } from '@material-ui/core'
import { margin } from 'polished'
import { MultiSelect } from './components/MultiSelect'
import useStyles from './styles'

const MaterialsFilters = ({
  filters,
  onFilter,
  currentPath,
  setLoading,
  selectNullGnombre,
  onReset,
  setOnReset
}) => {
  const [form, setForm] = useState(initialForm)
  const [change, setChange] = useState(initialChangeFalse)
  const [reset, setReset] = useState(false)

  const classes = useStyles()

  const categoriaNiveles = {
    1: 'Empresa',
    2: 'Categoría',
    3: 'Subcategoría',
    4: 'Marca',
  }

  const filtros = useMemo(() => formatFilters({ filters }), [filters])
  const [filterState, setFilterState] = useState(filtros)
  const [optionsDisplayed, setOptionsDisplayed] = useState(filtros)
  const [changeVertical, setChangeVertical] = useState(null)
  const [isDeleteNulls, setIsDeleteNulls] = useState(false)
  const copyNewArray = [...filters]

  const options = useMemo(() => {
    const filter = filtrarArray(copyNewArray, filterState)
    return formatFilters({ filters: filter })
  }, [optionsDisplayed, filterState])

  const onChangeMultiselect = (value, key) => {
    setFilterState({ ...filterState, [key]: value })
    setChange({ ...initialChangeTrue, [key]: false })
    const current = filtrarArray(copyNewArray, filterState)
    const formated = formatFilters({ filters: current })
    setOptionsDisplayed({ ...formated, [key]: optionsDisplayed[key] })
  }

  const onResetFilters = () => {
    setOptionsDisplayed(filtros)
    setFilterState(filtros)
    setChange(initialChangeFalse)
    setReset(true)
    setTimeout(() => setReset(false), 1000)
  }

  const handleFilter = () => {
    const body = { ...form, ...options }
    if (!options.gnombre) delete body.gnombre
    if (!options.pnombre) delete body.pnombre
    setForm(initialForm)
    onFilter({ form: body })
  }

  useEffect(() => {
    const newOptions = formatFilters({ filters })
    setOptionsDisplayed(newOptions)
    setFilterState(newOptions)
    if (!isDeleteNulls && newOptions.gnombre && !selectNullGnombre) {
      onChangeMultiselect(
        `${newOptions.gnombre.filter((item) => item !== 'NULL')}`,
        'gnombre',
      )
      setIsDeleteNulls(true)
    }
  }, [filters])

  useEffect(() => {
    if(onReset){
      handleFilter()
      console.log("ok")
      setOnReset(false)
    }
  }, [onReset])

  const handleCurrentPath = async () => {
    setLoading(true)
    onResetFilters()
    await new Promise((resolve) => setTimeout(resolve, 1000))
    for (const { value, nivel } of currentPath) {
      const categorie = categoriaNiveles[nivel] || ''
      setChangeVertical({ label: value, value, categorie })
      // Esperar 3 segundos antes de continuar con la siguiente iteración
      await new Promise((resolve) => setTimeout(resolve, 1500))
    }
    setLoading(false)
    handleFilter()
  }

  // const handleOnlyIce = () => {
  //   setChangeVertical({
  //     label: "AP",
  //     value: "AP",
  //     categorie: "Marca"
  // })
  // }

  useEffect(() => {
    if (currentPath) {
      handleCurrentPath()
    }
  }, [currentPath])

  useEffect(() => {
    if (optionsDisplayed) {
      console.log(optionsDisplayed, 'optionsDisplayed')
    }
  }, [])

  // if (loading) {
  //   return  <Card> <div> <h4 style={{ padding: '20px' }}>Cargando ⏳</h4></div></Card>
  // }

  return (
    <Card>
      <Typography className={classes.title}>Filtros</Typography>
      {filters.length > 0 && (
        <div className={classes.mainFiltersContainer}>
          <div className={classes.filtersContainer}>
            <MultiSelect
              label="Empresa"
              options={optionsDisplayed.vertical}
              values={options.vertical}
              change={change.vertical}
              reset={reset}
              changeVertical={changeVertical}
              onChange={(value) => onChangeMultiselect(value, 'vertical')}
            />
            <MultiSelect
              label="Clasificación"
              options={optionsDisplayed.clasificacion}
              values={options.clasificacion}
              change={change.clasificacion}
              reset={reset}
              onChange={(value) => onChangeMultiselect(value, 'clasificacion')}
            />
            <MultiSelect
              label="Categoría"
              options={optionsDisplayed.categoria}
              values={options.categoria}
              change={change.categoria}
              reset={reset}
              changeVertical={changeVertical}
              onChange={(value) => onChangeMultiselect(value, 'categoria')}
            />
            <MultiSelect
              label="Subcategoría"
              options={optionsDisplayed.subcategoria}
              values={options.subcategoria}
              change={change.subcategoria}
              reset={reset}
              changeVertical={changeVertical}
              onChange={(value) => onChangeMultiselect(value, 'subcategoria')}
            />
            <MultiSelect
              label="Marca"
              options={optionsDisplayed.marca}
              values={options.marca}
              change={change.marca}
              reset={reset}
              changeVertical={changeVertical}
              onChange={(value) => onChangeMultiselect(value, 'marca')}
            />
            <MultiSelect
              label="Acreedor"
              options={optionsDisplayed.acreedor}
              values={options.acreedor}
              change={change.acreedor}
              reset={reset}
              onChange={(value) => onChangeMultiselect(value, 'acreedor')}
            />
            <MultiSelect
              options={optionsDisplayed.familia}
              values={options.familia}
              change={change.familia}
              label="Familia"
              onChange={(value) => onChangeMultiselect(value, 'familia')}
            />
            <MultiSelect
              options={optionsDisplayed.estado_obsoleto}
              values={options.estado_obsoleto}
              change={change.estado_obsoleto}
              label="Estado material"
              onChange={(value) =>
                onChangeMultiselect(value, 'estado_obsoleto')
              }
            />
            <MultiSelect
              options={optionsDisplayed.segmento}
              values={options.segmento}
              change={change.segmento}
              label="Segmento"
              onChange={(value) => onChangeMultiselect(value, 'segmento')}
            />
            <MultiSelect
              options={optionsDisplayed.subsegmento}
              values={options.subsegmento}
              change={change.subsegmento}
              label="Sub Segmento"
              onChange={(value) => onChangeMultiselect(value, 'subsegmento')}
            />
            <MultiSelect
              label="Grupo de compra"
              options={optionsDisplayed.grupo_compras}
              values={options.grupo_compras}
              change={change.grupo_compras}
              reset={reset}
              onChange={(value) => onChangeMultiselect(value, 'grupo_compras')}
            />
            <MultiSelect
              label="Indicador ABC"
              options={optionsDisplayed.indicador_abc}
              values={options.indicador_abc}
              change={change.indicador_abc}
              reset={reset}
              onChange={(value) => onChangeMultiselect(value, 'indicador_abc')}
            />
            <MultiSelect
              label="Estado planeación de compras"
              options={optionsDisplayed.estado}
              values={options.estado}
              change={change.estado}
              reset={reset}
              onChange={(value) => onChangeMultiselect(`${value}`, 'estado')}
            />
            {optionsDisplayed.gnombre && (
              <MultiSelect
                label="Grupo nombre"
                options={optionsDisplayed.gnombre}
                values={options.gnombre}
                change={change.gnombre}
                reset={reset}
                gnombredeleteNull={selectNullGnombre}
                onChange={(value) => onChangeMultiselect(`${value}`, 'gnombre')}
              />
            )}

            {optionsDisplayed.pnombre && (
              <MultiSelect
                label="Perfil nombre"
                options={optionsDisplayed.pnombre}
                values={options.pnombre}
                change={change.pnombre}
                reset={reset}
                onChange={(value) => onChangeMultiselect(`${value}`, 'pnombre')}
              />
            )}
          </div>
          <div className={classes.btnsContainer}>
            <Button onClick={onResetFilters} className={classes.resetButton}>
              Restablecer filtros
            </Button>
            <Button
              variant="contained"
              color="warning"
              className={classes.ejectBtn}
              onClick={handleFilter}
            >
              Ejecutar
            </Button>
            {/* <Button onClick={handleOnlyIce} className={classes.onlyIceButton}>
              SOLAMENTE EMPRESA ICE
            </Button> */}
          </div>
        </div>
      )}
      <p
        style={{
          margin: '20px',
          fontSize: '20px',
          textAlign: 'center',
          cursor: 'pointer',
        }}
        onClick={handleFilter}
      >
        🔄
      </p>
    </Card>
  )
}

export { MaterialsFilters }
